<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>{{$router.currentRoute.meta.title}}</h3>
                    </div>
                      

                    <!-- Row -->
                    <div class="row">
                        <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">

                            <!-- Dashboard Box -->
                            <div class="col-xl-12">
                                <div class="dashboard-box margin-top-0">

                                    <!-- Headline -->
                                    <div class="headline">
                                        <h3><i class="material-icons">info</i> Informações gerais</h3>
                                    </div>

                                    <div class="content with-padding padding-bottom-0">

                                        <div class="row">

                                            <div class="col-xs-12" v-if="detalhes">
                                                <div class="submit-field">
                                                    <h5>Paciente:</h5>
                                                    <h4 class="margin-bottom-0">{{detalhes.PESSOA_FISICA.NM_PESSOA_FISICA}}</h4>
                                                    <small class="block margin-bottom-20">Código <b>{{detalhes.PESSOA_FISICA.CD_PESSOA_FISICA}}</b> / Atendimento <b>{{detalhes.ATENDIMENTOS_V ? detalhes.ATENDIMENTOS_V.NR_ATENDIMENTO || '-' : '-'}}</b> / Prontuário <b>{{detalhes.PESSOA_FISICA ? detalhes.PESSOA_FISICA.NR_PRONTUARIO || '-' : '-'}}</b></small>
                                                </div>
                                            </div>
                                            <div class="col-xs-12 col-xl-4 col-lg-4 col-md-6">
                                                <div class="submit-field">
                                                    <h5>Tipo da receita:</h5>
                                                    <select class="with-border" v-model="form.IE_TIPO_RECEITA">
                                                        <option value="" disabled selected hidden>Selecione aqui..</option>
                                                        <option value="C">Comum</option>
                                                        <option value="A">Amarela</option>
                                                        <option value="Z">Azul</option>
                                                        <option value="B">Branca duas vias</option>
                                                        <option value="S">SUS</option>
                                                    </select>
                                                </div>
                                            </div>    

                                            <div class="col-xs-12 col-xl-6 col-lg-6 col-md-6">
                                                <div class="submit-field">
                                                    <h5>Inserir texto padrão instituição:</h5>
                                                    <select class="with-border" v-model="form.NR_SEQUENCIA">
                                                        <option value="" disabled selected hidden>Selecione o texto..</option>
                                                        <option v-for="(item, index) in textos.itens" :value="item.NR_SEQUENCIA">{{item.DS_TITULO}}</option>
                                                        
                                                    </select>
                                                </div>
                                            </div> 

                                            <div class="col-xl-12 col-md-12 col-xs-12 col-lg-12">
                                                <div class="submit-field margin-bottom-20">
                                                    <h5>Conteúdo:</h5>
                                                    <trumbowyg v-model="form.DS_RECEITA" :config="config" class="form-control" name="DS_RECEITA"></trumbowyg>
                                                </div>
                                            </div>

                                            <div class="col-xl-3 col-xs-6 col-md-4 col-lg-4">
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>Data da receita</h5>
                                                </div>
                                                <input type="date" class="with-border" data-placeholder="___ /____ /_____" v-model="form.DT_RECEITA" required="">
                                            </div>

                                            <div class="col-xl-3 col-xs-6 col-md-4 col-lg-4">
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>Data de vigência</h5>
                                                </div>
                                                <input type="date" class="with-border" data-placeholder="___ /____ /_____" v-model="form.DT_VIGENCIA" required="">
                                            </div>                                            


                                            <!-- Button -->
                                            <div class="col-xl-12 margin-bottom-40">
                                                <div class="hidden-xs hidden-md margin-bottom-20"></div>
                                                <!-- <small class="help">O paciente receberá uma notificação no aplicativo.</small> -->
                                                <button type="submit" class="button green block-mobile">
                                                    <i class="material-icons">save</i>
                                                    Cadastrar receita
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name: 'GerenciarReceitas',
    components: {
        'Trumbowyg':                VueTrumbowyg.default,
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    data () {
        var self                    = this;
        return {
            "detalhes":             null,
            "textos": {
                "itens":            []
            },
            config: {
                svgPath:            "https://cdnjs.cloudflare.com/ajax/libs/Trumbowyg/2.20.0/ui/icons.svg",
                btns: [
                    // ['viewHTML'],
                    ['undo', 'redo'], // Only supported in Blink browsers
                    ['formatting'],
                    ['strong', 'em', 'del'],
                    // ['superscript', 'subscript'],
                    // ['link'],
                    // ['insertImage'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    ['unorderedList', 'orderedList'],
                    ['horizontalRule'],
                    // ['removeformat'],
                    // ['fullscreen']
                ]
            },    
            "form": {
                "_cod":             "",
                "_token":           "",
                "CD_PESSOA_FISICA": "",
                "NR_SEQUENCIA":     "",
                "IE_TIPO_RECEITA":  "",
                "DS_RECEITA":       "",
                "DT_VIGENCIA":      "",
                "DT_RECEITA":       "",
                
            }            
        }
    },
    watch: {
        "form.NR_SEQUENCIA": function(val) {
            var self = this;
            console.log("CHANGE", val)
            var texto = this.textos.itens.filter(function(item) {
                if (item.NR_SEQUENCIA == val) return item;
            })[0] || null;
            if (self.detalhes) {
                console.log("TEXTO", texto)
                if (texto) {
                    self.form.DS_RECEITA = texto.DS_TEXTO;
                    self.$forceUpdate();
                    self.replaceMacros();
                }
            }

        }
    },
    methods: {
        replaceMacros: function() {
            var self = this;
            console.log("replaceMacros()");
            var d   = new Date().toISOString().split("T")[0].split("-");
            var macros = [
                {
                    "nome": "@Data_Sem_Hora",
                    "valor": d[2] + "/" + d[1] + "/" + d[0]
                },
                {
                    "nome": "@nome",
                    "valor": self.detalhes.PESSOA_FISICA.NM_PESSOA_FISICA
                }                
            ];

            macros.forEach(function(item) {
                self.form.DS_RECEITA = self.form.DS_RECEITA.replaceAll(item.nome, item.valor); 
            });
            self.$forceUpdate();

        },
        submit: function(e) {
            var self            = this;
            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;
            console.log("submit()", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            loading.show();
                
            var a = "post";
            if (self.form.cod) {
                a = "put";
            }

            axios[a]("api/receitas.php", self.form)
            .then(response => {
                
                console.log("submit() response", response)
                loading.hide();
                alert(response.data.message);
                self.$root.back();

                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            // loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "CD_PESSOA_FISICA":  self.$route.query.CD_PESSOA_FISICA
                    }
                };

                axios.get("api/pacientes.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    
                    self.detalhes       = response.data.result;
                    self.loaded         = true;
                    // loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },
        getTextos: function() {
            var self        = this;
            console.log("get()", self.form);
            // loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "textos"
                    }
                };

                axios.get("api/receitas.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    
                    self.textos       = response.data.result;
                    self.loaded         = true;
                    // loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    // loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },        
    },    
    created: function() {
        var self = this;
        console.log("created", self);

        self.form.DT_RECEITA    = (new Date().toISOString()).split("T")[0];
        self.form.DT_VIGENCIA   = (new Date().toISOString()).split("T")[0];
        self.form.CD_PESSOA_FISICA =  self.$route.query.CD_PESSOA_FISICA;
        if (!self.$route.query.CD_PESSOA_FISICA) {
            self.$root.back();
            return false;
        }


        loading.show();

        Promise.all([
            self.get(),
            self.getTextos()
        ]).then(function() {
        
            setTimeout(function() {
                loading.hide();
            }, 500);
            
        }).catch(function(error) {
            loading.hide();
        });  

    },
    mounted: function() {
        if ($(".selectpicker").length > 0) {
            setTimeout(function() {
                $('.selectpicker').selectpicker('refresh');
            }, 100);
        }        
    }     
} 
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/GerenciarReceitas.vue